import type { PostDonationParameters } from "../api";

export type ReceiptFormValues = {
  displayName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  mobile?: string;
  salutation?: "mr" | "miss" | "ms";
  receiptTitle?: string;
};

// 匿名只控制公开姓名；是否索取收据独立控制私密资料，避免提交隐藏旧值。
export function receiptPayload(
  values: ReceiptFormValues,
  needsReceipt: boolean,
  isAnonymous: boolean,
): Partial<PostDonationParameters> {
  return {
    donorName: isAnonymous
      ? undefined
      : values.displayName?.trim() || undefined,
    isAnonymous,
    receiptOption: needsReceipt ? "e_receipt" : "no_thanks",
    receiptTitle: needsReceipt ? values.receiptTitle?.trim() : undefined,
    donorEmail: needsReceipt ? values.email?.trim() : undefined,
    firstName: needsReceipt ? values.firstName?.trim() : undefined,
    lastName: needsReceipt ? values.lastName?.trim() : undefined,
    mobileNumber:
      needsReceipt && values.mobile ? `+852${values.mobile.trim()}` : undefined,
    salutation: needsReceipt ? values.salutation : undefined,
  };
}

// 按已确认规则使用严格大于，HK$100本身不符合收据条件。
export const isReceiptEligible = (amount: number) =>
  Number.isFinite(amount) && amount > 100;
